import { Action, Reducer, createStore, combineReducers } from 'redux';
import { useSelector, useDispatch } from "react-redux";
import { AppThunkAction } from '..';
// models
import * as Models from '../../models/config/PullJobStatus'
import { extractAccessToken } from "../../helpers/jwt";

// Load
interface LoadPullJobStatus {
    type: 'LOAD_PULLJOBSTATUS'
}
interface LoadedPullJobStatus {
    type: 'LOADEDPULLJOBSTATUS'
    response: Models.ResponsePullJobStatus
    status: number,
    statusMessage: string
}
interface FailLoadedPullJobStatus {
    type: 'LOADPULLJOBSTATUSFAIL'
    status: number,
    statusMessage: any
}
interface ClearLoadedPullJobStatus {
    type: 'CLEARLOADPULLJOBSTATUS'
    status: number,
    statusMessage: any
}

interface NoUserLoadedPullJobStatus {
    type: 'NOUSERLOADPULLJOBSTATUS'
}

type KnownAction = NoUserLoadedPullJobStatus | LoadedPullJobStatus | FailLoadedPullJobStatus | LoadPullJobStatus | ClearLoadedPullJobStatus

export const actionCreators = {
    requestGetPullJobStatus: (check: boolean, method: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        if (appState && appState.PullJobStatus && check && method == 'GET') {
            fetch(`/v1/pull-job-status`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('LG_APPLICATION'),
                },
            })
                .then((response) => {
                    return response
                })
                .then((data) => {
                    if (!data.ok) {
                        data.json().then(err => {
                            dispatch({ type: 'LOADPULLJOBSTATUSFAIL', status: 204, statusMessage: err.message });
                        })
                    } else {
                        data.json().then(data => {
                            console.log(data);
                            dispatch({ type: 'LOADEDPULLJOBSTATUS', response: data, status: 200, statusMessage: '' });
                        })
                    }
                })
            //dispatch({ type: 'LOADEDPULLJOBSTATUS', response: data, status: 200, statusMessage: '' });
            //dispatch({ type: 'LOADPULLJOBSTATUSFAIL', status: 204, statusMessage: error.message });
            dispatch({ type: 'LOAD_PULLJOBSTATUS' });
        } else if (appState && appState.PullJobStatus && check && method == 'NOUSER') {
            dispatch({ type: 'NOUSERLOADPULLJOBSTATUS' });
        }
    },
}

const unloadedState: Models.GetPullJobStatusState = { isLoadPullJobStatus: false };
const reducerGet: Reducer<Models.GetPullJobStatusState> = (state: Models.GetPullJobStatusState | undefined, incomingAction: Action): Models.GetPullJobStatusState => {
    if (state == undefined) {
        return unloadedState;
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'LOAD_PULLJOBSTATUS':
            return {
                isLoadPullJobStatus: false,
            }

        case 'LOADEDPULLJOBSTATUS':
            return {
                isLoadPullJobStatus: true,
                responsePullJobStatus: action.response as any,
                statusPullJobStatus: action.status
            }

        case 'LOADPULLJOBSTATUSFAIL':
            return {
                isLoadPullJobStatus: true,
                messagePullJobStatus: action.statusMessage,
                statusPullJobStatus: action.status
            }

        case 'CLEARLOADPULLJOBSTATUS':
            return {
                isLoadPullJobStatus: false,
                messagePullJobStatus: "",
                statusPullJobStatus: 400
            }

        case 'NOUSERLOADPULLJOBSTATUS':
            return {
                isLoadPullJobStatus: false,
                statusPullJobStatus: 400
            }
        default: return state;
    }
}

export const rootReducer = combineReducers({ GetPullJobStatus: reducerGet });